// extracted by mini-css-extract-plugin
export var deleteModal = "_f2-0";